import { always } from "ramda";
import { useMemo } from "react";
import { useDispatch } from "react-redux";

import { isReduxAction } from "../utilities/matchers";

export const useOnChangeAction = (
  action: (payload?: unknown) => (arg: string) => void
):
  | (<T>(val: T) => () => T)
  | ((val: string) => (arg: string) => void)
  | ((arg: string) => void) => {
  const dispatch = useDispatch();
  const dispatchedAction = useMemo(
    () => (val: string) => dispatch(action(val)),
    [dispatch, action]
  );

  if (action === undefined) {
    return always;
  }

  if (isReduxAction(action)) {
    return dispatchedAction;
  }

  return action();
};
